import { createElement, isValidElement, ReactChild } from 'react';

import { RenderPropBasic, RenderPropFC } from '../../types';

export const isValidReactChild = (value: unknown): value is ReactChild =>
  isValidElement(value) ||
  typeof value === 'string' ||
  typeof value === 'number';

export const renderBasicRenderProp = <TProps extends {}>(
  renderProp: RenderPropBasic<TProps>,
  props: TProps,
): ReactChild | null | undefined => {
  if (typeof renderProp === 'function') {
    return renderProp(props);
  }

  if (isValidReactChild(renderProp)) {
    return renderProp;
  }

  return null;
};

export const renderFCRenderProp = <TProps extends {}>(
  renderProp: RenderPropFC<TProps>,
  props: TProps,
): ReactChild | null | undefined => {
  if (typeof renderProp === 'function') {
    return createElement<TProps>(renderProp, props);
  }

  if (isValidReactChild(renderProp)) {
    return renderProp;
  }

  return null;
};
